<div class="edit-group-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <h2 class="dialog-title">Edit Group</h2>
    <button mat-icon-button aria-label="Close" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content">
    <!-- Group Name Section -->
    <form [formGroup]="groupForm" class="group-form">
      <div class="group-name-section">
        <mat-form-field appearance="outline" class="group-name-field">
          <mat-label>Group Name</mat-label>
          <input
            matInput
            formControlName="name"
            placeholder="Enter group name">
            @if (groupForm.get('name')?.invalid && groupForm.get('name')?.touched) {
              <div>
                @if (groupForm.get('name')?.errors?.['required']) {
                  <mat-error>Group name is required</mat-error>
                }
                @if (groupForm.get('name')?.errors?.['alphanumericSpace']) {
                  <mat-error>Group name can only contain letters, numbers, and spaces</mat-error>
                }
                @if (groupForm.get('name')?.errors?.['uniqueName']) {
                  <mat-error>A group with this name already exists</mat-error>
                }
              </div>
            }
          </mat-form-field>
        </div>
      </form>

      <!-- Permissions Section -->
      <div class="permissions-section">
        <h3 class="permissions-title">Permissions</h3>
        <div class="permissions-list">
          @for (p of existingPermissions; track p) {
            <div class="permission-item">
              <span class="permission-name">{{ p.permission }}</span>
              <mat-checkbox
                [checked]="p.enabled"
                (change)="onPermissionToggle(p)"
                class="permission-checkbox">
              </mat-checkbox>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Dialog Footer -->
    <div class="dialog-footer">
      <button
        mat-raised-button
        color="primary"
        [disabled]="(!groupForm.dirty && !permissionsChanged) || doingAction"
        (click)="save()"
        class="save-button">
        @if (doingAction) {
          <mat-spinner diameter="20"></mat-spinner>
        }
        @if (!doingAction) {
          <span>Save</span>
        }
      </button>
    </div>
  </div>
